<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <b-card :title="service_title" class="mr-1 ml-1">
        <b-row>
        <b-col>
            <p class="alert-message p-2"><b>ATTENZIONE!</b> Esplora attentamente tutte le possibilità di scelta offerte dalla sezione "buoni", ma ricorda che una volta inviata la richiesta d'acquisto di un prodotto/buono specifico, essa non potrà essere annullata.</p>
        </b-col>
        </b-row>
        <b-row>
        <b-col>
            <b-form ref="sso_form">
                <b-form-group id="group-ok-condizioni">
                    <b-form-checkbox
                    id="ok-condizioni"
                    name="ok-condizioni"
                    :value="true"
                    :unchecked-value="false"
                    v-model="conditions_checkbox"
                    required>
                    <span class="font-italic">Confermo di voler accedere al portale {{service_title}} e di essere consapevole che i buoni opzionati non potranno essere annullati.</span>
                    </b-form-checkbox>
                </b-form-group>
                <!-- Lavorando questo SSO in GET e non dovendo quindi effettuare la POST dei dati tramite form come per -->
                <!-- tantosvago, all'apertura del link l'evento di click apre la pagina di cortesia di redirect alla home -->
                <b-button v-if="show_submit_btn" :href="login_url" target="_blank" @click="$router.replace( { name : 'conv-redirect', params:  { page_title : service_title } } )" variant="primary">Accedi al portale {{service_title}}</b-button>
            </b-form>
        </b-col>
        </b-row>
        <!-- Uno slot per del contenuto addizionale sotto al form -->
        <slot name="form-footer"></slot>
    </b-card>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'WishListLogin',
  data () {
    return {

        // Variabili generali
        tagline_elem : [ { text : "Buoni - Welfarebit by Wishlist", link : 'conv-wishlist' } ],

        service_title : "Buoni - Welfarebit by Wishlist",

        // Checkbox di conferma delle condizioni
        conditions_checkbox: false,

        // Url di login che rappresenta la GET da effettuare per
        // eseguire l'SSO verso wishlist.
        login_url: null
    }
  },
  computed : {
    /**
     * Visualizza o meno il bottone di invio del form sulla base del valore della checkbox.
     */
    show_submit_btn : function () {
      return  this.conditions_checkbox === true ? true : false;
    }
  },
  created : function () {
    /* Costruisco la stringa criptata con i dati utente e l'url di login */
    axios.post( apiUrl.welfareapi.create_acq_wishlist_login )
    .then( ( response ) => {
      this.login_url = response.data.login_url;
    })
    .catch( ( error ) => {
      generalLib.backend_error_message_box( this, error.response.data );
    });
  },
  components: {
    PageTagline
  }
}
</script>

<style scoped>
.alert-message{
  color: #721c24;
  background-color: #f8d7da;
}
</style>